export enum OryConstants {
  returnTo = 'return_to',
}

export const oryBasePath = process.env.NEXT_PUBLIC_ORY_SDK_URL;
